//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import axios from '~/plugins/axios';
import animationTimeout from '../../plugins/animation-timeout';

import PageLimiter from '../PageLimiter.vue';
import PageBanner from '../PageBanner.vue';
import Breadcrumbs from '../Breadcrumbs.vue';
import Btn from '../Btn.vue';
import IconArrow from '../IconArrow.vue';
import PageOverlay from '../PageOverlay.vue';
import FeedbackForm from '../FeedbackForm.vue';
import PageContent from '../PageContent.vue';

export default {
	name: 'PageCooperation',

	components: { PageLimiter: PageLimiter, Btn: Btn, IconArrow: IconArrow, PageBanner: PageBanner, Breadcrumbs: Breadcrumbs, PageOverlay: PageOverlay, FeedbackForm: FeedbackForm, PageContent: PageContent },

	props: {
		page: {
			type: Object,
			default: function _default() {
				return {};
			}
		},

		crumbs: {
			type: Array,
			default: function _default() {
				return [];
			}
		}
	},

	data: function data() {
		return {
			joinFormIsClear: false,
			activeDocsTabIndex: 0
		};
	},


	computed: {
		joinIsShow: function joinIsShow() {
			return !!this.$route.query.join;
		},
		docsIsShow: function docsIsShow() {
			return !!this.$route.query.docs;
		},
		productMeta: function productMeta() {
			var section = this.page.productMetaSection || {};
			return section.productMeta || [];
		},
		productFeatures: function productFeatures() {
			var section = this.page.productFeaturesSection || {};
			return section.productFeatures || [];
		},
		offerFeatures: function offerFeatures() {
			var section = this.page.offerSection || {};
			return section.offerFeatures;
		},
		feedback: function feedback() {
			return this.$store.state.settings.feedbackTile.form || {};
		},
		showSteps: function showSteps() {
			if (this.$store.state.settings.lang == 'en') return false;else return true;
		}
	},

	methods: {
		setDocsTab: function setDocsTab(index) {
			this.activeDocsTabIndex = index;
		},
		animateCounter: function animateCounter(el) {
			this.$refs.counter.forEach(function (el) {
				el.innerHTML = el.getAttribute('data-value');
			});
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/pages/PageCooperation.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/pages/PageCooperation.vue
// module chunks = 0